import pluralize from 'pluralize'
import { upperFirst, lowerFirst } from 'lodash'

import { DEFAULT_SESSIONS_TITLE } from '../../constants'

export class SessionTitleFormatter {
  title = DEFAULT_SESSIONS_TITLE

  setTitle(title) {
    if (!title) {
      return
    }

    this.title = title
  }

  format(text) {
    const multipleSessionsTitle = this.title
    const singleSessionTitle = pluralize.singular(multipleSessionsTitle)

    return text
      .replace(/\bSessions\b/g, upperFirst(multipleSessionsTitle))
      .replace(/\bsessions\b/g, lowerFirst(multipleSessionsTitle))
      .replace(/\bSession\b/g, upperFirst(singleSessionTitle))
      .replace(/\bsession\b/g, lowerFirst(singleSessionTitle))
  }
}

export const sessionTitleFormatter = new SessionTitleFormatter()
